import { Component } from '@angular/core';
import { TranslateService, TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-privacy-policies',
    templateUrl: './privacy-policies.component.html',
    styleUrl: './privacy-policies.component.scss',
    imports: [TranslateModule]
})
export class PrivacyPoliciesComponent {
  constructor(private _translate: TranslateService) {}
}
